import { selectors } from "reducers/token";
import * as i18n from "util/i18n";
import { isMobileNative } from "util/device";
import * as configUtils from "util/config";
import * as secureStorageUtils from "util/secureStorage";
import { store } from "../store";

const isTokenActive = () => {
    if (isMobileNative) {
        const tokenActive = selectors.getIsTokenActiveInThisDevice(store.getState());
        return tokenActive;
    }
    return false;
};

export const isActiveInOtherDevice = () => {
    let isActive = false;
    const isTokenActiveInDevice = selectors.getIsTokenActiveInThisDevice(store.getState());
    const userHasActiveToken = selectors.userHasActiveToken(store.getState());
    if (isMobileNative) {
        isActive = userHasActiveToken && !isTokenActiveInDevice;
    }
    return isActive;
};

export const getResponseMessage = (response) => {
    const tokenMessage = response?.data?.data?.otp && i18n.get("token.otp.invalid");
    const noField = response?.data?.data?.NO_FIELD;
    const message = noField || tokenMessage || response.data.message;
    return message;
};

export const getToken = (tokenSeed, expirationTime, tDiff) =>
    window.softToken.getToken({ tokenSeed, expirationTime, tDiff });

export const isTokenSeedAvailable = async () => {
    try {
        return secureStorageUtils
            .get("tokenSeed")
            .then((seed) => !!seed) // Si tiene valor, devuelve true
            .catch(() => false);
    } catch (error) {
        return false;
    }
};

export const shouldRemoveSeedFromDevice = () => {
    const useOfflineToken = configUtils.getBoolean("backend.show.Token.offline");
    return !isTokenActive() || !useOfflineToken;
};

export default isTokenActive;
